var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.show
    ? _c("studip-dialog", {
        attrs: {
          height: "720",
          width: "960",
          title: _vm.$gettext("Bild hinzufügen"),
          closeClass: "cancel",
          closeText: _vm.$gettext("Abbrechen"),
        },
        on: {
          close: _vm.onCancel,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "dialogContent",
              fn: function fn() {
                return [
                  _c(
                    "form",
                    {
                      staticClass: "default",
                      attrs: {
                        id: "stock-images-upload-form",
                      },
                      on: {
                        submit: function submit($event) {
                          $event.preventDefault()
                          return _vm.onSubmit.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm.state === _vm.STATES.IDLE
                        ? _c("UploadBox", {
                            on: {
                              upload: _vm.onUpload,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.state === _vm.STATES.UPLOADED
                        ? _c("MetadataBox", {
                            attrs: {
                              file: _vm.file,
                              metadata: _vm.metadata,
                              "suggested-tags": _vm.suggestedTags,
                            },
                            on: {
                              change: _vm.onChangeMetadata,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "dialogButtons",
              fn: function fn() {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "button accept",
                      attrs: {
                        form: "stock-images-upload-form",
                        type: "submit",
                        disabled: _vm.state !== _vm.STATES.UPLOADED,
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$gettext("Hinzufügen")) +
                          "\n        "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          907283859
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }